module.exports = __webpack_public_path__ + "img/art-51.f4bfb109.png";